import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Comments from '../components/Comments';
import articles from '../data/articles';

const brandLinks = {
 'Studio Nicholson': 'https://www.studionicholson.com/',
 'Carne Bollente': 'https://www.carnebollente.com/',
 'COS': 'https://www.cos.com/',
 'St\u00fcssy': 'https://www.stussy.com/',
 'Stussy': 'https://www.stussy.com/',
 'Lemaire': 'https://www.lemaire.fr/',
 'Nike': 'https://www.nike.com/',
 'Aim\u00e9 Leon Dore': 'https://www.aimeleondore.com/',
 'New Balance': 'https://www.newbalance.com/',
 'Auralee': 'https://auralee.jp/',
 'Amomento': 'https://en.amomento.co.kr/',
 'Akai': 'https://www.akaipro.com/',
 'Roland': 'https://www.roland.com/',
 'Ableton': 'https://www.ableton.com/',
 'FL Studio': 'https://www.image-line.com/',
 'Buddakan': 'https://buddakannyc.com/',
 'Westlight': 'https://westlightnyc.com/',
 'Juliana\u2019s': 'https://julianaspizza.com/',
 'Dante': 'https://www.dante-nyc.com/',
 'House of Yes': 'https://houseofyes.org/',
};

function renderWithLinks(text, accentColor) {
 const parts = [];
 let remaining = text;
 while (remaining.length > 0) {
  let earliest = null;
  let earliestIdx = remaining.length;
  for (const brand of Object.keys(brandLinks)) {
   const idx = remaining.indexOf(brand);
   if (idx !== -1 && idx < earliestIdx) {
    earliestIdx = idx;
    earliest = brand;
   }
  }
  if (!earliest) {
   parts.push(remaining);
   break;
  }
  if (earliestIdx > 0) parts.push(remaining.slice(0, earliestIdx));
  parts.push(
   <a key={parts.length} href={brandLinks[earliest]} target="_blank" rel="noopener noreferrer" style={{ color: accentColor, textDecoration: 'underline', textUnderlineOffset: '3px' }}>{earliest}</a> );
  remaining = remaining.slice(earliestIdx + earliest.length);
 }
 return parts;
}

const worldColors = {
 music: { accent: '#C41E3A', bg: '#080808', navTheme: 'dark' },
 fashion: { accent: '#C41E3A', bg: '#080808', navTheme: 'dark' },
 lifestyle: { accent: '#C41E3A', bg: '#080808', navTheme: 'dark' },
 'the-voice': { accent: '#C41E3A', bg: '#080808', navTheme: 'dark' },
};
const socials = [
 { label: 'Instagram', url: 'https://www.instagram.com/flyshitnyc' },
 { label: 'TikTok', url: 'https://www.tiktok.com/@flyshitnyc' },
 { label: 'X / Twitter', url: 'https://x.com/flyshitnyc' },
];

export default function Article() {
 const { slug } = useParams();
 const article = articles.find((a) => a.slug === slug);

 if (!article) {
  return (
   <div style={{ background: '#0a0a0a', color: '#fff', minHeight: '100vh' }}> <Navbar /> <div style={{ padding: '10rem 2rem', textAlign: 'center' }}> <h1 style={{ fontFamily: "'Arial', 'Helvetica Neue', sans-serif", fontSize: '2rem', marginBottom: '1rem' }}>Article Not Found</h1> <Link to="/" style={{ color: '#F5C518', textDecoration: 'underline' }}>Back to Home</Link> </div> </div> );
 }

 const colors = worldColors[article.world] || worldColors.music;
 const isDark = colors.navTheme === 'dark';
 const midIndex = Math.floor(article.content.length / 2);

 return (
  <div style={{ background: colors.bg, color: isDark ? '#fff' : '#111', minHeight: '100vh' }}> <Navbar theme={colors.navTheme} /> {/* Hero — conditional: wrap layout or standard */}
   {article.wrapImage ? (
    <> {/* Wrap-style header */}
     <div style={{ maxWidth: 800, margin: '0 auto', padding: '0 2rem 0' }}> <span style={{
       fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
       fontSize: '0.65rem',
       letterSpacing: 3,
       color: colors.accent,
       display: 'block',
       marginBottom: '0.5rem',
      }}> {article.tag}
      </span> <h1 style={{
       fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
       fontSize: 'clamp(1.8rem, 5vw, 3.2rem)',
       fontWeight: 700,
       lineHeight: 1.1,
       marginBottom: '1.5rem',
      }}> {article.title}
      </h1> </div> </> ) : (
    <div style={{
     position: 'relative',
     width: '100%',
     height: 'clamp(300px, 50vw, 500px)',
     overflow: 'hidden',
     marginTop: 0,
    }}> <img
      src={article.image}
      alt={article.title}
      style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
     /> <div style={{
      position: 'absolute',
      inset: 0,
      background: `linear-gradient(transparent 40%, ${colors.bg} 100%)`,
     }} /> <div style={{
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      padding: 'clamp(1.5rem, 4vw, 3rem)',
      maxWidth: 800,
      margin: '0 auto',
     }}> <span style={{
       fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
       fontSize: '0.65rem',
       letterSpacing: 3,
       color: colors.accent,
       display: 'block',
       marginBottom: '0.5rem',
      }}> {article.tag}
      </span> <h1 style={{
       fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
       fontSize: 'clamp(1.6rem, 5vw, 3rem)',
       fontWeight: 700,
       lineHeight: 1.1,
       textShadow: isDark ? '0 2px 20px rgba(0,0,0,0.5)' : 'none',
      }}> {article.title}
      </h1> </div> </div> )}

   {/* Article body */}
   <article style={{ maxWidth: 720, margin: '0 auto', padding: '2rem 2rem 4rem' }}> <p style={{
     fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
     fontSize: '1.05rem',
     color: isDark ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
     lineHeight: 1.6,
     marginBottom: '2.5rem',
     paddingBottom: '1.5rem',
     borderBottom: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'}`,
    }}> {article.preview}
    </p> {/* Wrap image layout with gallery */}
    {article.wrapImage && (
     <div> {/* Main article image — original size */}
      <div style={{ marginBottom: '2rem' }}> <img
        src={article.image}
        alt={article.title}
        style={{ width: '100%', height: 'auto', display: 'block', borderRadius: 12 }}
       /> </div> {/* All paragraphs together */}
      {article.content.map((p, i) => (
       <p key={i} style={{
        fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
        fontSize: '1.05rem',
        lineHeight: 1.85,
        color: isDark ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.8)',
        marginBottom: '1.5rem',
       }}> {renderWithLinks(p, colors.accent)}
       </p> ))}

      {/* Gallery images — each at original size, on their own line */}
      {article.galleryImages && article.galleryImages.length > 0 && (
       <div style={{ marginTop: '2rem' }}> {article.galleryImages.map((img, i) => (
         <div key={i} style={{ marginBottom: '1.5rem' }}> <img
           src={img}
           alt=""
           style={{ width: '100%', height: 'auto', display: 'block', borderRadius: 12 }}
          /> </div> ))}
       </div> )}
     </div> )}

    {/* Standard layout (non-wrap) */}
    {!article.wrapImage && (
     <> {/* First half of content */}
      {article.content.slice(0, midIndex).map((p, i) => (
       <p key={i} style={{
        fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
        fontSize: '1.05rem',
        lineHeight: 1.85,
        color: isDark ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.8)',
        marginBottom: '1.5rem',
       }}> {renderWithLinks(p, colors.accent)}
       </p> ))}

      {/* Pull quote */}
      {article.pullQuote && (
       <blockquote style={{
        margin: '2.5rem 0',
        padding: '2rem 2rem 2rem 1.5rem',
        borderLeft: `4px solid ${colors.accent}`,
        background: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.03)',
        borderRadius: '0 12px 12px 0',
       }}> <p style={{
         fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
         fontSize: 'clamp(1.1rem, 3vw, 1.5rem)',
         fontStyle: 'italic',
         lineHeight: 1.5,
         color: isDark ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.9)',
        }}> "{article.pullQuote}"
        </p> </blockquote> )}

      {/* Second half of content */}
      {article.content.slice(midIndex).map((p, i) => (
       <p key={i + midIndex} style={{
        fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
        fontSize: '1.05rem',
        lineHeight: 1.85,
        color: isDark ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.8)',
        marginBottom: '1.5rem',
       }}> {renderWithLinks(p, colors.accent)}
       </p> ))}
     </> )}

    {/* Pull quote for wrap articles */}
    {article.wrapImage && article.pullQuote && (
     <blockquote style={{
      margin: '1rem 0 2.5rem',
      padding: '2rem 2rem 2rem 1.5rem',
      borderLeft: `4px solid ${colors.accent}`,
      background: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.03)',
      borderRadius: '0 12px 12px 0',
      clear: 'both',
     }}> <p style={{
       fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
       fontSize: 'clamp(1.1rem, 3vw, 1.5rem)',
       fontStyle: 'italic',
       lineHeight: 1.5,
       color: isDark ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.9)',
      }}> "{article.pullQuote}"
      </p> </blockquote> )}

    {/* Back + socials */}
    <div style={{
     marginTop: '3rem',
     paddingTop: '2rem',
     borderTop: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'}`,
     display: 'flex',
     flexWrap: 'wrap',
     justifyContent: 'space-between',
     alignItems: 'center',
     gap: '1rem',
    }}> <Link
     to="/articles"
     style={{
       fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
       fontSize: '0.85rem',
       fontWeight: 800,
       letterSpacing: 2,
       padding: '0.8rem 2rem',
       borderRadius: 0,
       background: colors.accent,
       color: '#fff',
       textDecoration: 'none',
      }}
     > ALL ARTICLES
     </Link> <div style={{ display: 'flex', gap: '1rem' }}> {socials.map((s) => (
       <a
        key={s.label}
        href={s.url}
        target="_blank"
        rel="noopener noreferrer"
        style={{
         fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
         fontSize: '0.7rem',
         letterSpacing: 1,
         color: colors.accent,
         textDecoration: 'none',
         padding: '0.4rem 0.8rem',
         border: `1px solid ${colors.accent}40`,
         borderRadius: 50,
        }}
       > {s.label}
       </a> ))}
     </div> </div> {/* Comments */}
    <Comments articleSlug={article.slug} isDark={isDark} accent={colors.accent} /> </article> <footer style={{
    textAlign: 'center',
    padding: '2rem',
    fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
    fontSize: '0.7rem',
    letterSpacing: 3,
    color: isDark ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
   }}> FLYSHIT NYC
   </footer> </div> );
}
